import { render, staticRenderFns } from "./DialogTenderFinish.vue?vue&type=template&id=7d23fdb0"
import script from "./DialogTenderFinish.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogTenderFinish.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports